(function () {
	var App = angular.module('pphhApp');
	App.controller("updateCodeTableController", ["$scope", "$window", "$http", "updateCodeTableService",
		function($scope, $window, $http, updateCodeTableService) {
	
			$scope.mastercNames = "";
			$scope.selected = [];
	
			$scope.init = function () {
				$scope.getListMC();
			};
	
	
			/**
			 * Callback que se invoca cuando la operación de carga se ha realizado
			 * correctamente.
			 */
			var uploadFileSuccessCallback = function (response) {
				$scope.isLoading = false;
				var errorMessages = response.data.errorMessages;
				var field = errorMessages[0];
				$scope.message = field.message;
				$scope.closeButton = false;
			};
	
			/**
			 * Callback que se invoca cuando se ha producido algún error durante la
			 * operación de carga.
			 */
			var uploadFileErrorCallback = function (response) {
				$scope.isLoading = false;
				var errorMessages = response.data.errorMessages;
				if(errorMessages != null){
					var field = errorMessages[0];
					$scope.message = field.message;
				}else{
	
					$scope.message = response;
				}
			};
	
			$scope.uploadFilea = function(a) {
				$scope.isLoading = true;
				var file = $scope.file;
				var selectd = angular.toJson($scope.selected);
				$scope.message ="";
				updateCodeTableService.uploadFile(file,selectd).then(uploadFileSuccessCallback, uploadFileErrorCallback);
			};
	
			/**
			 * Callback que se invoca cuando la operación de carga se ha realizado
			 * correctamente.
			 */
			var getListMCSuccessCallback = function (response) {
				$scope.mastercNames = response.lst;
			};
	
			$scope.getListMC = function() {
				updateCodeTableService.listMasterCodes().then(getListMCSuccessCallback);
			};
	
			$scope.toggle = function (item, list) {
		        var idx = list.indexOf(item);
		        if (idx > -1) {
		          list.splice(idx, 1);
		        }else {
		          list.push(item);
		        }
		      };
	
		   $scope.exists = function (item, list) {
	          return list.indexOf(item) > -1;
	       };
	}]);
})();
